const Picture = ({ label = '', url, fill = false }) => {
  const box = fill ? 'h-32 lg:h-auto lg:min-h-0 lg:flex-1' : 'h-32';

  return (
    <div className={`flex flex-col ${fill ? 'lg:h-full' : ''}`}>
      {label && <p className="mb-1.5 shrink-0 text-xs text-secondary-400">{label}</p>}

      {url ? (
        <a href={url} target="_blank" rel="noreferrer" title="Open full size" className={`group block ${box}`}>
          <img
            src={url}
            alt={label}
            className="h-full w-full rounded-lg border border-gray-200 bg-white object-contain p-1.5 transition-opacity group-hover:opacity-90"
          />
        </a>
      ) : (
        <div className={`flex items-center justify-center rounded-lg border border-dashed border-gray-200 bg-gray-50/70 ${box}`}>
          <p className="text-xs text-secondary-300">Not added</p>
        </div>
      )}
    </div>
  );
};

export default Picture;
